var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h4", [_vm._v("安装")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
          _vm._v("npm  i  mi-vant -D\n")
        ])
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("引入组件")]),
      _vm._v(" "),
      _c("h5", [
        _vm._v(
          "webpack中的配置  以vue2.x脚手架举例 在/build/webpack.base.conf.js中配置即可"
        )
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
          _c("span", { attrs: { class: "hljs-built_in" } }, [_vm._v("module")]),
          _vm._v(".exports = {\n  ...\n  resolve: {\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("extensions")]),
          _vm._v(": ["),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'.less'")]),
          _vm._v(",...],\n }\n  ...\n}\n")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("注意")]),
        _vm._v(
          "  按需引入时，引入的是组件库中单个组件的less文件 请引入之前添加less-loader进行解析"
        )
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("方式一   自动按需引入组件")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
          _c("span", { attrs: { class: "hljs-comment" } }, [
            _vm._v(
              "// MiButton组件中内置了单个组件所需的样式  无需配置babel-plugin-import"
            )
          ]),
          _vm._v("\n "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" { MiButton, Modal } "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'miVant'")]),
          _vm._v("\n "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" Vue "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'vue'")]),
          _vm._v("\n\n Vue.use(MiButton)\n Vue.use(Modal)\n")
        ])
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("方式二  手动按需引入组件")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" MiButton "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'miVant/lib/Button'")
          ]),
          _vm._v("\n"),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" Modal "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'miVant/lib/Modal'")
          ]),
          _vm._v("\n"),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" Vue "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'vue'")]),
          _vm._v("\n\n Vue.use(MiButton)\n Vue.use(Modal)\n")
        ])
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("方式三  导入所有组件")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" miVant "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'miVant'")]),
          _vm._v("\n "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("import")]),
          _vm._v(" Vue "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("from")]),
          _vm._v(" "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'vue'")]),
          _vm._v("\n\n Vue.use(miVant)\n")
        ])
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v("rem适配")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Vant 中的样式默认使用"),
        _c("code", { pre: true }, [_vm._v("px")]),
        _vm._v("作为单位，如果需要使用"),
        _c("code", { pre: true }, [_vm._v("rem")]),
        _vm._v("单位，推荐使用以下两个工具")
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://github.com/cuth/postcss-pxtorem" } },
            [_vm._v("postcss-pxtorem")]
          ),
          _vm._v(" 是一款 postcss 插件，用于将单位转化为 rem")
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "https://github.com/amfe/lib-flexible" } }, [
            _vm._v("lib-flexible")
          ]),
          _vm._v(" 用于设置 rem 基准值")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "下面提供了一份基本的 postcss 配置，可以在此配置的基础上根据项目需求进行修改"
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("p", [
            _vm._v(
              "类似于babel的执行原理，Postcss-loader 会自动解析根目录下的postcss.config.js"
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [_c("p", [_vm._v("注意： 需要设置html中的根字体大小")])])
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
          _c("span", { attrs: { class: "hljs-built_in" } }, [_vm._v("module")]),
          _vm._v(".exports = {\n  "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("plugins")]),
          _vm._v(": {\n    "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'autoprefixer'")
          ]),
          _vm._v(": {\n      "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("browsers")]),
          _vm._v(": ["),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'Android >= 4.0'")
          ]),
          _vm._v(", "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'iOS >= 7'")
          ]),
          _vm._v("]\n    },\n    "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v('"postcss-px2rem"')
          ]),
          _vm._v(": { "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("remUnit")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-number" } }, [_vm._v("100")]),
          _vm._v(" }\n  }\n}\n")
        ])
      ]),
      _vm._v(" "),
      _c("blockquote", [
        _c("p", [
          _vm._v(
            "注意：在配置 postcss-loader 时，应避免\b ignore node_modules 目录，这会导致 miVant 的样式无法被编译"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib!./node_modules/vue-markdown-loader/lib/markdown-compiler.js??ref--1-1!./docs/quickStart.md?vue&type=template&id=1117a55c&
// module id = null
// module chunks = 